import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=11702124&scoped=true"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"
import style0 from "./WorldMap.vue?vue&type=style&index=0&id=11702124&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11702124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11702124')) {
      api.createRecord('11702124', component.options)
    } else {
      api.reload('11702124', component.options)
    }
    module.hot.accept("./WorldMap.vue?vue&type=template&id=11702124&scoped=true", function () {
      api.rerender('11702124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/external/WorldMap.vue"
export default component.exports